export class DiagnosisGroup {
  identifier: string;
  items: DiagnosisGroupItem[];
  useOdontogram: boolean;

  constructor(identifier: string, useOdontogram: boolean = true) {
    this.identifier = identifier;
    this.items = [];
    this.useOdontogram = useOdontogram;
  }
}

export class DiagnosisGroupItem {
  identifier: string;
  components?: string[];
  mainComponent?: string;
  saveAction?: string;
  selectionMode?: string;

  constructor(
    identifier: string,
    components: string[] = [],
    mainComponent: string = "odontogram",
    saveAction: string = "AddItemAction",
    selectionMode: string = "single",
  ) {
    this.identifier = identifier;
    this.components = components;
    this.mainComponent = mainComponent;
    this.saveAction = saveAction;
    this.selectionMode = selectionMode;
  }
}

export class DiagnosisItem {
  id?: number;
  condition: string;
  options: ItemOptions;
  observations?: string;
  teeth: number[];
  valid?: boolean;

  constructor() {
    this.condition = "";
    this.observations = "";
    this.teeth = [];
    this.options = new ItemOptions();
    this.valid = false;
  }
}

export class ItemOptions {
  surfaces?: string[];
  degree?: string;
  location?: string;
  options?: string[];
  name?: string;
  status?: string;

  constructor() {
    this.surfaces = [];
    this.degree = null;
    this.location = null;
    this.options = [];
    this.name = null;
    this.status = null;
  }
}

export class ToothDiagnosis {
  condition: string;
  options?: string;
}

export class MalocclusionsOptions {
  malo_class?: number;
  midline_shift?: boolean;
  crowding?: boolean;
  spacing?: boolean;
  overlap?: string;
  bite?: string;
  crossbit?: boolean;
  disharmony?: boolean;

  constructor() {
    this.malo_class = 1;
    this.midline_shift = false;
    this.crowding = false;
    this.spacing = false;
    this.overlap = "";
    this.bite = "";
    this.crossbit = false;
    this.disharmony = false;
  }
}

export class FacialOptions {
  profile: string;
  lower: string;

  constructor() {
    this.profile = "normal";
    this.lower = "normal";
  }
}

export class TmjOptions {
  bruxism: boolean;
  tmj_disorder: boolean;
  muscle_disorder: boolean;

  constructor() {
    this.bruxism = false;
    this.tmj_disorder = false;
    this.muscle_disorder = false;
  }
}

export class Diagnosis360 {
  crooked_shifting: boolean;
  darkening: boolean;
  missing_drifting: boolean;
  decay_infection: boolean;
  problems_existing_treatments: boolean;
  bite_joint: boolean;
  gum_disease: boolean;
  enamel_damage: boolean;
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/diagnosis.model.ts